import { To } from 'react-router-dom';

export const getLastPathElement = (path: string | To) => path.toString().split('/').pop() ?? '';
